import React, {useEffect, useState} from 'react';

import "./Login.scss";
import Title from "../../components/Title/Title";
import backgroundLogin from '../../assets/images/login-background.jpg';
import AuthMsal from "../../components/AuthMsal/AuthMsal";

const Login = props => {

    const [loadedClass, setLoadedClass] = useState(false);

    const loginStyle = {
        backgroundImage: 'url(' + backgroundLogin + ')',
    };

    useEffect(() => {
        if(!loadedClass) {
            setTimeout(() => {
                setLoadedClass(true);
            }, 100);
        }
    });

    return (
        <div className={'login' + (loadedClass ? ' login--loaded' : '')} style={loginStyle}>
            <div className={'container-fluid'}>
                <div className={'row'}>
                    <div className={'login__content'}>
                        <Title type={'h5'} headline={true}>Tableau de bord Tryba</Title>
                        <Title type={'h1'}>Bienvenue sur votre application Tryba</Title>
                        {/*<p className={'p--medium'}>Retrouvez en 1 clic toutes vos applications et tous vos sites métier.</p>*/}
                    </div>
                    <div className={'login__form'} >
                        <div className={'w-iframe'}>
                            <AuthMsal />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
